export { default as AccordionCartDetails } from './AccordionCartDetails';
